import {
  Component,
  OnInit,
  ViewChild,
  DoCheck,
  OnDestroy,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  ModalController,
  IonSlides,
  IonContent,
  Platform,
} from '@ionic/angular';
import { first } from 'rxjs/operators';
import { AlertService, AuthenticationService, GlobalService } from 'src/app/shared/_services';
import { TermsPage } from 'src/app/shared/modals/terms/terms.page';
import { PrivacyPage } from 'src/app/shared/modals/privacy/privacy.page';
import { CloseOverlayService } from 'src/app/shared/_services/closeOverlay.service';
import { Location } from '@angular/common';
import { ShadowService } from 'src/app/shared/_services/shadow.service';
import { DashboardStore, LoginStore, SignupStore } from 'src/app/shared/_services/store';
@Component({
  selector: 'app-signup',
  templateUrl: './signup.page.html',
  styleUrls: ['./signup.page.scss'],
})
export class SignupPage implements OnInit, DoCheck, OnDestroy {
  @ViewChild('signUpSlides', { static: true }) slides: IonSlides;
  @ViewChild(IonContent, { static: false }) content: IonContent;
  @ViewChild('lgaId', { static: true }) lgaElement: any;

  showIcon = true;
  showIcon2 = true;
  loading = false;
  disabled = true;
  disableNext = true;
  isUnverified = false;
  isInvalid = false;
  serverError = false;
  lgaSelected = true;
  businessDetails = true;
  accountDetails = false;
  isNewAccount: boolean;
  signUpForm: FormGroup;
  error: string;
  subscription: any;
  bankAccountDetails: any;
  bvnDetails: any;
  inputType = 'password';
  inputType2 = 'password';
  banks = this.loginStore.getBanks();
  filteredBanks = this.loginStore.getFilteredBanks();
  states: Array<object>;
  lgas: Array<object> = this.signupStore.getLgas();
  lgaPlaceholder = 'LGA';
  referralId = this.loginStore.getReferralId();
  bvnError = 'Please check your BVN';
  title: string;
  cordova: boolean;
  desktop: boolean;
  emptyString = '';
  businessTypes = [
    { name: 'Art/Entertainment' },
    { name: 'Building/Construction' },
    { name: 'Clothing/Textile' },
    { name: 'Gadgets/Electronics' },
    { name: 'Health/Beauty' },
    { name: 'Hospitality' },
    { name: 'Product/Services' },
    { name: 'Restaurant/Bar' },
    { name: 'Supermarket/Retail' },
    { name: 'Travel/Tourism' },
    { name: 'Vehicles/Machinery' },
  ];
  selectState: HTMLElement;

  constructor(
    private router: Router,
    private location: Location,
    private platform: Platform,
    private route: ActivatedRoute,
    private loginStore: LoginStore,
    private formBuilder: FormBuilder,
    private signupStore: SignupStore,
    private alertService: AlertService,
    private auth: AuthenticationService,
    private shadowService: ShadowService,
    private globalService: GlobalService,
    private dashboardStore: DashboardStore,
    private modalController: ModalController,
    private closeOverlayService: CloseOverlayService
  ) {}

  public errorMessages = {
    name: [
      { type: 'required', message: 'Business Name is required' },
      {
        type: 'minlength',
        message: 'Business Name cannot be less than 3 characters',
      },
      // { type: 'maxlength', message: 'Business Name cannot be more than 25 characters' }
    ],
    businessType: [{ type: 'required', message: 'Business Type is required' }],
    address: [
      { type: 'required', message: 'Business Address is required' },
      {
        type: 'minlength',
        message: 'Business Address cannot be less than 5 characters',
      },
    ],
    email: [
      { type: 'required', message: 'Email is required' },
      { type: 'pattern', message: 'Please enter a valid email address' },
    ],
    phone: [
      { type: 'required', message: 'Phone Number is required' },
      { type: 'minlength', message: 'Phone number must be 11 digits' },
      { type: 'maxlength', message: 'Phone number must be 11 digits' },
      { type: 'pattern', message: 'Please enter only digits' },
    ],
    accountNumber: [
      { type: 'required', message: 'Account Number is required' },
      { type: 'minlength', message: 'Account Number must be  10 digits' },
      { type: 'maxlength', message: 'Account Number must be  10 digits' },
      { type: 'pattern', message: 'Please enter only digits' },
    ],
    accountName: [{ type: 'required', message: 'Account Name is required' }],
    bank: [{ type: 'required', message: 'Bank is required' }],
    bvn: [
      { type: 'required', message: 'BVN is required' },
      { type: 'minlength', message: 'BVN should be 11 digits' },
      { type: 'maxlength', message: 'BVN should be 11 digits' },
      { type: 'pattern', message: 'Please enter only digits' },
    ],
    password: [
      { type: 'required', message: 'Password is required' },
      { type: 'minlength', message: '' },
      {
        type: 'pattern',
        message:
          'Password cannot be less than 8 characters' +
          ' and must contain a minimum of 1 Uppercase Letter, 1 Special Character and 1 Number',
      },
    ],
    confirmPassword: [
      { type: 'required', message: 'Please retype your password' },
      { type: 'minlength', message: '' },
      {
        type: 'pattern',
        message:
          'Password cannot be less than 8 characters and must contain a minimum' +
          ' of 1 Uppercase Letter, 1 Special Character and 1 Number',
      },
    ],
  };

  get name() {
    return this.signUpForm.get('name');
  }
  get businessType() {
    return this.signUpForm.get('businessType');
  }
  get address() {
    return this.signUpForm.get('address');
  }
  get email() {
    if (this.isNewAccount !== true) {
      return this.signUpForm.get('email');
    }
  }
  get phone() {
    return this.signUpForm.get('phone');
  }
  get accountNumber() {
    return this.signUpForm.get('accountNumber');
  }
  get accountName() {
    return this.signUpForm.get('accountName');
  }
  get firstName() {
    return this.signUpForm.get('firstName');
  }
  get lastName() {
    return this.signUpForm.get('lastName');
  }
  get invitedBy() {
    return this.signUpForm.get('invitedBy');
  }
  get bank() {
    return this.signUpForm.get('bank');
  }
  get state() {
    return this.signUpForm.get('state');
  }
  get lga() {
    return this.signUpForm.get('lga');
  }
  get bvn() {
    return this.signUpForm.get('bvn');
  }
  get password() {
    if (this.isNewAccount !== true) {
      return this.signUpForm.get('password');
    }
  }
  get confirmPassword() {
    if (this.isNewAccount !== true) {
      return this.signUpForm.get('confirmPassword');
    }
  }

  passwordConfirm(formGroup: FormGroup) {
    if (this.isNewAccount !== true) {
      const { value: password } = formGroup.get('password');
      const { value: confirmPassword } = formGroup.get('confirmPassword');
      return password === confirmPassword ? null : { passwordNotMatch: true };
    }
  }

  next() {
    this.businessDetails = false;
    this.accountDetails = true;
    this.content.scrollToTop(1500);
    console.log('Go to next slide');
  }

  prev() {
    this.businessDetails = true;
    this.accountDetails = false;
  }

  goBack() {
    if (this.isNewAccount !== true) {
      this.router.navigateByUrl('/login');
      window.onpopstate = () => {
        this.closeOverlayService.trigger();
      };
    } else {
      this.router.navigateByUrl('/dashboard');
    }
  }

  togglePassword() {
    this.showIcon = !this.showIcon;
    this.inputType === 'password'
      ? (this.inputType = 'text')
      : (this.inputType = 'password');
  }

  toggleBvn() {
    this.showIcon2 = !this.showIcon2;
    this.inputType2 === 'password'
      ? (this.inputType2 = 'number')
      : (this.inputType2 = 'password');
  }

  getBankAccountName() {
    const { cbn } = this.filteredBanks.find(
      (bank) => bank.name === this.bank.value
    );
    if (cbn.length === 3) {
      if (this.accountNumber.value.length === 10) {
        this.alertService.loading('Getting Bank Account Name...');
        this.auth.getBankAccountName(this.accountNumber.value, cbn).subscribe(
          (response: any) => {
            console.log(response);
            // console.log(response.desc.split(' '));
            // this.firstName.setValue(response.desc.split(' ')[1]);
            // this.lastName.setValue(response.desc.split(' ')[0]);
            const details = JSON.stringify(response);
            this.bankAccountDetails = JSON.parse(details);
            this.accountName.setValue(response.desc);
            this.alertService.stopLoading();
          },
          (error) => {
            console.log(error);
            this.serverError = true;
            this.alertService.stopLoading();
            this.alertService.standardAlert(
              'Failed. Please Check your Bank Account details and try again'
            );
          }
        );
      }
    }
  }

  getBvn() {
    if (this.bvn.value.length === 11) {
      this.bvnError = '';
      this.alertService.loading('Verifying BVN...');
      this.auth.getBvn(this.bvn.value).subscribe(
        async (response: any) => {
          console.log(response);
          const details = JSON.stringify(response);
          this.bvnDetails = JSON.parse(details);
          this.firstName.setValue(this.bvnDetails.Data.FirstName);
          this.lastName.setValue(this.bvnDetails.Data.Lastname);
          this.isUnverified = false;
          this.alertService.stopLoading();
          this.alertService.standardAlertWithButton(
            response.ResponseDescription,
            response.Data.FirstName +
              ' ' +
              response.Data.MiddleName +
              ' ' +
              response.Data.Lastname,
            true,
            'Ok'
          );
        },
        (error) => {
          console.log(error);
          this.auth.getBvn2(this.bvn.value).subscribe(
            (response: any) => {
              console.log(response);
              if (response.responseCode === '00') {
                this.firstName.setValue(response.responseObject.firstName);
                this.lastName.setValue(response.responseObject.lastName);
                this.isUnverified = false;
                this.alertService.stopLoading();
                this.alertService.standardAlertWithButton(
                  response.responseDescription,
                  response.responseObject.firstName +
                    ' ' +
                    response.responseObject.middleName +
                    ' ' +
                    response.responseObject.lastName,
                  true,
                  'Ok'
                );
              } else if (response.responseCode === '96') {
                this.bvnError =
                  'Failed. Please check your BVN and try again';
                this.isUnverified = true;
                this.firstName.setValue('');
                this.lastName.setValue('');
                this.alertService.stopLoading();
                this.alertService.standardAlertWithButton(
                  'Error Validating BVN',
                  '',
                  true,
                  'Ok'
                );
              } else if (response.status >= 400 && response.status <= 500) {
                this.bvnError =
                  'BVN service is currently unavailable. Please try again';
              } else {
                this.bvnError = 'Failed. Please try again';
              }
            },
            (err) => {
              console.log(err);
              this.isUnverified = true;
              this.firstName.setValue('');
              this.lastName.setValue('');
              this.alertService.stopLoading();
              this.alertService.standardAlert(
                // tslint:disable-next-line:max-line-length
                'Failed. Please check your BVN and try again.<br/> If problem persists, please be patient. Service would be restored soon'
              );
            }
          );
        }
      );
    }
  }

  getLga(state: any) {
    const selectedLga: any = this.states.find(
      (item: any) => item.name === state.value
    );
    this.signupStore.setLgas(state.lga || selectedLga.lga);
    this.lgas = this.signupStore.getLgas();
    this.lga.setValue('');
    this.lgaSelected = false;
    if (this.cordova) {
      this.lgaElement.placeholder = 'Select LGA';
      this.shadowService.actionSheet();
    }
  }

  selectLga() {
    this.signupStore.setSelectedLga(this.lga.value);
    this.setOpacity();
    this.lgaSelected = true;
  }

  setOpacity() {
    if (this.cordova) {
      this.lgaElement.el.shadowRoot
      .querySelector('.select-text')
      .setAttribute('style', 'opacity: 1');
    }
  }

  createAccount() {
    this.error = null;
    if (this.signUpForm.invalid) {
      this.loading = false;
      return;
    }

    this.loading = true;
    this.isNewAccount === true
      ? this.name.setValue(
          this.signupStore.getName() +
            ' - ' +
            this.auth.currentUserValue.details.name
        )
      : this.signupStore.getName();
    setTimeout(() => {
      this.auth
        .createAccount(this.signUpForm.value)
        .pipe(first())
        .subscribe(
          (response: any) => {
            this.signupStore.setName(this.name.value.split(' -')[0]);
            this.name.setValue(this.signupStore.getName());
            // this.router.navigate(['/verify-email'], { queryParams: { registered: true } });
            this.loading = false;
            console.log(response);
            if (this.isNewAccount !== true) {
              this.alertService.retry(
                'Sign Up successful! <br/> Please login',
                3000,
                false
              );
              this.dashboardStore.setCurrentUser(JSON.stringify(response));
              setTimeout(() => {
                this.router.navigateByUrl('/login');
              }, 3000);
            } else {
              this.signupStore.setNewAccount(response.details);
              // this.dashboardStore.setAccountSummary(JSON.stringify(response.details));
              // this.dashboardStore.setAccountId(response.details.id.toString());
              this.dashboardStore.setIsNewAccountAdded(true);
              this.alertService.retry(
                'Account added successfully! <br/> Taking you back to your Dashboard',
                3000,
                false
              );
              setTimeout(() => {
                this.router.navigateByUrl('/dashboard');
                this.auth.removeItems();
              }, 3000);
            }
          },
          (error) => {
            this.signupStore.setName(this.name.value.split(' -')[0]);
            this.name.setValue(this.signupStore.getName());
            const errorMessage = error.error.message;
            this.error = error.error.message.includes('bvn_unique')
              ? 'BVN Must Be Unique'
              : error.error.message;
            this.loading = false;
            if (error.error.message.includes('connect ETIMEDOUT')) {
              this.alertService.loadingNullDuration(
                'Connection Timed Out. Please check your internet connection and try again'
              );
            } else if (error.error.message.includes('email must be unique')) {
              this.alertService.standardAlertWithButton(
                '',
                'Hmm. You have signed up already with this email. Please login',
                true,
                'Login'
              );
            } else if (
              error.error.message.includes('accountNumber must be unique') ||
              error.error.message.includes('phone must be unique') ||
              error.error.message.includes('bvn must be unique')
            ) {
              this.alertService.standardAlertWithButton(
                '',
                'Error: ' +
                  errorMessage.toUpperCase() +
                  '.<br/> <br/> This credential has been taken.' +
                  '<br/> <br/> Trying to add a new branch of your buiness? Login now to Add a new account',
                true,
                'Login'
              );
            } else {
              this.alertService.standardAlertNullDuration(
                'Uh Oh! Your sign up failed. Please try again <br/> <br/>' +
                  errorMessage.toUpperCase().includes('bvn_unique')
                  ? 'BVN Must Be Unique'
                  : errorMessage.toUpperCase()
              );
            }
            console.log(error);
          }
        );
    }, 1000);
  }

  async terms() {
    const modal = await this.modalController.create({
      component: TermsPage,
      cssClass: 'bottom-modal',
      backdropDismiss: true,
      swipeToClose: true,
    });
    return await modal.present();
  }

  async privacy() {
    const modal = await this.modalController.create({
      component: PrivacyPage,
      cssClass: 'bottom-modal',
      backdropDismiss: true,
      swipeToClose: true,
    });
    return await modal.present();
  }

  ionViewWillEnter() {
    document.title = this.title + '| Bank3D';
    this.shadowService.button();
    if (this.signupStore.getSelectedLga()) {
      this.setOpacity();
    }
    this.banks.find((bank: any) => {
      if (this.loginStore.getReferralId() === '381') {
        if (bank.cbn === '084') {
          this.filteredBanks = [bank];
        }
      } else {
        this.filteredBanks = this.banks;
      }
    });
  }

  ionViewDidEnter() {
    this.loginStore.setIsSignupPage(true);
    this.selectState = document.getElementById('select-state');
    this.subscription = this.platform.backButton.subscribeWithPriority(
      99999,
      () => {
        if (this.constructor.name === 'SignupPage') {
          this.closeOverlayService.trigger();
        } else {
          this.location.back();
        }
      }
    );
  }

  ionViewDidLeave() {
    this.subscription.unsubscribe();
  }
  ngOnInit() {
    this.cordova = this.platform.is('cordova');
    this.desktop = this.platform.is('desktop');
    this.signUpForm = this.formBuilder.group(
      {
        name: [
          this.signupStore.getName(),
          [Validators.required, Validators.minLength(3)],
        ],
        businessType: [
          this.signupStore.getBusinessType(),
          Validators.required,
        ],
        address: [
          this.signupStore.getAddress(),
          [Validators.minLength(5), Validators.required],
        ],
        email: [
          this.signupStore.getEmail(),
          [
            Validators.required,
            Validators.pattern('^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$'),
          ],
        ],
        phone: [
          this.signupStore.getPhone(),
          [
            Validators.required,
            Validators.minLength(11),
            Validators.maxLength(11),
            Validators.pattern('^[0-9]*$'),
          ],
        ],
        accountNumber: [
          '',
          [
            Validators.required,
            Validators.minLength(10),
            Validators.maxLength(10),
            Validators.pattern('^[0-9]*$'),
          ],
        ],
        accountName: [{ value: '', disabled: true }, Validators.required],
        firstName: [''],
        lastName: [''],
        invitedBy: [this.loginStore.getReferralId()],
        bank: [this.signupStore.getSelectedBank()],
        state: [this.signupStore.getSelectedState()],
        lga: [this.signupStore.getSelectedLga()],
        bvn: [
          '',
          [
            Validators.required,
            Validators.minLength(11),
            Validators.maxLength(11),
            Validators.pattern('^[0-9]*$'),
          ],
        ],
        password: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            Validators.pattern(
              '((?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\\W]).{8,})'
            ),
          ],
        ],
        confirmPassword: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            Validators.pattern(
              '((?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\\W]).{8,})'
            ),
          ],
        ],
      },
      {
        validators: this.passwordConfirm.bind(this),
      }
    );
    this.globalService.getStates();
    this.states = this.signupStore.getStates();
    this.bankAccountDetails = '';
    window.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && this.disableNext === false) {
        this.closeOverlayService.trigger();
        this.next();
      }
      const pathname = window.location.pathname;
      if (
        e.key === 'Enter' &&
        this.disabled === false &&
        pathname.includes('signup')
      ) {
        this.createAccount();
      }
    });
  }

  ngDoCheck() {
    const newAccount = 'addNewAccount';
    if (this.route.snapshot.queryParams[newAccount]) {
      this.title = 'Add New Account ';
      this.isNewAccount = true;
      if (
        this.name.valid &&
        this.businessType.valid &&
        this.address.valid &&
        this.phone.valid &&
        this.state.value !== '' &&
        this.lga.value !== ''
      ) {
        this.disableNext = false;
      } else {
        this.disableNext = true;
      }
      this.signupStore.setIsAccountNew(this.isNewAccount);
      this.bvn.setValue(this.auth.currentUserValue.details.bvn);
      delete this.signUpForm.controls.email;
      delete this.signUpForm.controls.password;
      delete this.signUpForm.controls.confirmPassword;
      delete this.signUpForm.value.email;
      delete this.signUpForm.value.password;
      delete this.signUpForm.value.confirmPassword;
    } else {
      this.signupStore.setEmail(this.email.value);
      this.title = 'Signup ';
      if (
        this.name.valid &&
        this.businessType.valid &&
        this.address.valid &&
        this.email.valid &&
        this.phone.valid &&
        this.state.value !== '' &&
        this.lga.value !== ''
      ) {
        this.disableNext = false;
      } else {
        this.disableNext = true;
      }
      // if (this.bankAccountDetails.bvn !== this.bvn.value) {
      //   this.alertService.retry('BVN is not linked to your bank account', null, true);
      //   console.log(this.lga.value, this.bankAccountDetails.bvn, this.bvn.value);
      // }
    }
    this.signupStore.setName(this.name.value);
    this.signupStore.setBusinessType(this.businessType.value);
    this.signupStore.setAddress(this.address.value);
    this.signupStore.setPhone(this.phone.value);
    this.signupStore.setSelectedState(this.state.value);
    this.signupStore.setSelectedLga(this.lga.value);
    this.signupStore.setSelectedBank(this.bank.value);
    if (
      this.signupStore.getName() &&
      this.signupStore.getName().includes('null')
    ) {
      this.signupStore.setName(this.emptyString);
    }
    if (this.signupStore.getBusinessType() === 'null') {
      this.signupStore.setBusinessType(this.emptyString);
    }
    if (this.signupStore.getAddress() === 'null') {
      this.signupStore.setAddress(this.emptyString);
    }
    if (this.signupStore.getEmail() === 'null') {
      this.signupStore.setEmail(this.emptyString);
    }
    if (this.signupStore.getPhone() === 'null') {
      this.signupStore.setPhone(this.emptyString);
    }
    if (this.signupStore.getSelectedState() === 'null') {
      this.signupStore.setSelectedState(this.emptyString);
    }
    if (this.signupStore.getSelectedLga() === 'null') {
      this.signupStore.setSelectedLga(this.emptyString);
    }
    if (this.signupStore.getSelectedBank() === 'null') {
      this.signupStore.setSelectedBank(this.emptyString);
    }
    if (this.loginStore.getReferralId() === '381') {
      this.bank.setValue('Heritage');
    }
    if (!this.signUpForm.valid) {
      this.disabled = true;
    } else if (
      this.bankAccountDetails.code === '07' ||
      this.serverError === true
    ) {
      this.isInvalid = true;
      this.disabled = true;
    } else if (this.isUnverified === true) {
      this.isUnverified = true;
      this.disabled = true;
    } else {
      this.disabled = false;
    }
    this.accountName.value.includes('Error getting')
      ? (this.isInvalid = true)
      : (this.isInvalid = false);
    if (this.signupStore.getSelectedLga()) {
      this.lgaPlaceholder = this.signupStore.getSelectedLga();
    }
    if (this.desktop || !this.cordova) {
      const selectBusinessType = document.getElementById('select-business-type');
      const selectState = document.getElementById('select-state');
      const selectLga = document.getElementById('select-lga');
      const selectBank = document.getElementById('select-bank');
      if (this.signupStore.getBusinessType().length > 0 && selectBusinessType) {
        selectBusinessType.style.color = '#082C4C';
      }
      if (this.signupStore.getSelectedState().length > 0 && selectState) {
        selectState.style.color = '#082C4C';
      }
      if (this.signupStore.getSelectedLga().length > 0 && selectLga) {
        selectLga.style.color = '#082C4C';
      }
      if (this.signupStore.getSelectedBank().length > 0 && selectBank) {
        selectBank.style.color = '#082C4C';
      }
    }
    return this.signUpForm;
  }

  ngOnDestroy(): void {}
}
